'use client';

import { useSuperstarDetailContext } from './context';
import {
  EntourageListItem,
  EntourageListItemProps,
} from '@wwe-portal/ui/features/roster/entourage-list-item';
import { FC } from 'react';
import { EntourageList } from '@wwe-portal/entities/superstar-stats.type';
import { cloneArrayWithId } from '@wwe-portal/utils/array';

export const EntourageConsumer: FC = () => {
  const entourages = useSuperstarDetailContext(
    (state) => state.statsSheet?.entourages
  );

  const parseEntourageData = (entourages: EntourageList) => {
    const result: EntourageListItemProps = {
      data: {
        superstarInfo: entourages.superstarInfo,
        effects: entourages.effects.map((effect, index) => ({
          ...effect,
          relatedEffect: index === 0,
        })),
      },
    };
    return result;
  };

  if (!entourages) {
    return null;
  }

  return (
    <>
      <div className="drop-shadow-text-2 mb-1 mt-4 text-sm font-bold uppercase italic text-[#00BFFF]">
        Entourage
      </div>
      <div className="flex flex-col gap-2 bg-[#191D3C] py-4">
        {cloneArrayWithId(entourages).map((entourage) => (
          <EntourageListItem
            {...parseEntourageData(entourage)}
            key={entourage.id}
          />
        ))}
      </div>
    </>
  );
};
